import { MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: "transparent",
  borderRadius: "10px",
  padding: "5px 8px",
  margin: "4px 10px",
  fontFamily: "Outfit",
  "&:hover": {
    backgroundColor: "var(--input-bg-color) !important",
  },
  "&.Mui-selected": {
    backgroundColor: "var(--input-bg-color) !important",
  },
}));
